export const EMAIL_SETTINGS_SET_REPLY_TO = 'EMAIL_SETTINGS_SET_REPLY_TO'
export const EMAIL_SETTINGS_SET_REPLY_TO_RESPONSE = 'EMAIL_SETTINGS_SET_REPLY_TO_RESPONSE'

export const EMAIL_SETTINGS_SET_SENDER_NAME = 'EMAIL_SETTINGS_SET_SENDER_NAME'
export const EMAIL_SETTINGS_SET_SENDER_NAME_RESPONSE = 'EMAIL_SETTINGS_SET_SENDER_NAME_RESPONSE'
